import React, { memo } from "react";
import { useSelector } from "react-redux";
import InPlayItem from "../InPlayItem/inplayitem";
import { headerType } from "../../helpers/InPlayPopular.helper";
import EventTypeBanners from "../EventTypeBanners/EventTypeBanners";
import SVG_CricketIcon from "../../assets/images/svgs/cricket.svg?react";
import SVG_TennisIcon from "../../assets/images/svgs/tennis.svg?react";
import SVG_FootballIcon from "../../assets/images/svgs/football.svg?react";
import { CricketSVG, FootballSVG, TennisSVG } from "../SvgImage/SvgImage";

const InPlayPopularItemList = ({
  type,
  itemHeaderData,
  balanceSetting,
  timeSettings,
  itemsData,
  displayedBack,
  setDisplayedBack,
  betPlacing,
}) => {
  const user = useSelector((state) => state.user);
  const checkStateWidth = useSelector(
    (state) => state.elementsParams.clientWidth
  );
  const width = checkStateWidth ? checkStateWidth : window.innerWidth;

  const getHeaderIcon = () => {
    switch (itemHeaderData.id) {
      case 1: {
        return <FootballSVG height={20} width={20} color={"#ef8402"}/>;
      }

      case 2: {
        return <TennisSVG height={20} width={20} color={"#ef8402"}/>;
      }

      case 4: {
        return <CricketSVG height={20} width={20} color={"#ef8402"} />;
      }

      default:
        return "";
    }
  };

  const getBanner = () => {
    if (headerType["INPLAY"] == type) {
      return <EventTypeBanners eventType={itemHeaderData.id} />;
    } else return null;
  };

  const renderHeader = () => {
    if (itemsData.length == 0) return null;

    return (
      <>
        <div className="text-text_Ternary  px-2 h-full py-2.5 col-span-6 lg:col-span-5 pl-2 flex items-center justify-start w-full gap-x-2 border-t-[color:var(--border-borderColorOfMarket)] border-t border-solid">
          <span>{getHeaderIcon()}</span>

          <div className="text-text_Ternary  md:text-[18px] text-base font-semibold leading-3 tracking-wide text-center">
            {itemHeaderData.name}
          </div>
        </div>

        {(itemHeaderData.id === 1 ||
          itemHeaderData.id === 4 ||
          itemHeaderData.id === 2) && (
          <div className=" col-span-6 py-2.5 lg:col-span-7 grid grid-cols-12 h-full border-t-[color:var(--border-borderColorOfMarket)] border-t border-solid">
            <span className="text-text_Ternary  text-xs font-semibold col-span-4 text-center flex items-center justify-center tracking-0.3">
              1
            </span>
            <span className="text-text_Ternary  text-xs font-semibold col-span-4 text-center flex items-center justify-center tracking-0.3">
              X
            </span>
            <span className="text-text_Ternary  text-xs font-semibold col-span-4 text-center flex items-center justify-center tracking-0.3">
              2
            </span>
          </div>
        )}
      </>
    );
  };

  if (
    user?.verifytoken &&
    !user?.details?.availableEventTypes.includes(`${itemHeaderData.id}`)
  ) {
    return null;
  }

  return (
    <>
      <div className="bg-bg_Quaternary rounded-b border border-ternary4 border-t-0 border-b-0 shadow-lg">
        <div className="eventHeadName grid grid-cols-12">
          {getBanner()}
          {renderHeader()}

          {itemsData &&
            itemsData.map((itemData, index) => {
              if (itemData.eventType == "SPORTSBOOK") return null;

              return (
                <InPlayItem
                  type={type}
                  betPlacing={betPlacing}
                  timeSettings={timeSettings}
                  balanceSetting={balanceSetting}
                  displayedBack={displayedBack}
                  setDisplayedBack={setDisplayedBack}
                  key={index}
                  itemData={itemData}
                />
              );
            })}
        </div>
      </div>
    </>
  );
};

export default memo(InPlayPopularItemList);
